import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { permitsAnalyticsForPath } from './utils/analyticsPrivacy';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const posthogKey = process.env.REACT_APP_POSTHOG_KEY || '';
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const analyticsEnabled = Boolean(posthogKey) &&
  permitsAnalyticsForPath(window.location.pathname);

// Enrollment links carry an opaque invitation in the URL fragment. Analytics
// must stay uninitialized for the entire private enrollment flow so the
// browser cannot capture that fragment before React removes it from history.
if (analyticsEnabled) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_exceptions: true,
    // Chat is decrypted only in the browser. Never record its rendered contents.
    disable_session_recording: true,
    debug: process.env.NODE_ENV === 'development',
  });
}

root.render(
  <React.StrictMode>
    {analyticsEnabled ? (
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
